<template>
  <boxwrap class="notices--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          ref="toolbarNav"
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="active"
            name="active"
          >
            <span>active</span>
          </select-option>

          <select-option
            value="inactive"
            name="inactive"
          >
            <span>inactive</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>

        </select-list>

        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          @click="showCreate = true"
          title="create"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length"
          @click="restore()"
        >
          <i class="ico--restore"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @click="checkAll(notices)"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                v-if="checkCol('id', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="title"
                :sort="true"
                v-if="checkCol('title', tblSetting)"
              >
                title
              </tbl-td>

              <tbl-td
                name="content"
                :sort="true"
                v-if="checkCol('content', tblSetting)"
              >
                content
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td
                name="actions"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(row, index) in notices"
              @click.native="select(row)"
              :key="row.id"
              :class="{'is-deleted': row.deleted_at }"
            >
              <tbl-td name="checkbox" @click.native.stop>
                <checkbox>
                  <input type="checkbox"
                    v-model="selected"
                    :value="row.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(index, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ row.created_at | date }}
              </tbl-td>

              <tbl-td
                name="title"
                v-if="checkCol('title', tblSetting)"
                :isHtml="true"
                :logs="row.title"
              >
              </tbl-td>

              <tbl-td
                name="content"
                v-if="checkCol('content', tblSetting)"
                :isHtml="true"
                :logs="row.content"
              >
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ row.updated_at | date}}
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span v-if="row.deleted_at">
                  {{ row.deleted_at | date}}
                </span>
                <span v-else> - </span>
              </tbl-td>

              <tbl-td
                name="actions"
                @click.native.stop
              > <!-- v-if="checkCol('created_at', tblSetting)" -->
                <checkbox
                  type="toggle"
                  :class="{'-active': !row.is_hidden}"
                  toggleA="show"
                  toggleB="hide"
                  @click.native.stop.prevent="visibility(row)"
                >
                  <input
                    type="checkbox"
                    v-model="row.is_hidden"
                  />
                </checkbox>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            v-model="params.page"
            :total="count"
            :limit="params.rows"
            :rows="params.rows"
            @page="trigger">
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-notice"
      title="create notice"
      :activate="showCreate"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showCreate"
      @activate="event => { showCreate = event, reset() }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="createParams.title"
                >
                </quill-editor>
              </div>
            </div>
          </div>
          <div class="form-items">
            <div class="form-lbl"><span>content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillContentConfig"
                  v-model="createParams.content"
                >
                </quill-editor>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="save('createParams')"
        >
          <i class="ico--save"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-notice"
      :title="'modify notice'"
      :activate="showModify"
      :draggable="true"
      :bodyOverflow="true"
      v-if="showModify"
      @activate="event => { showModify = event, reset() }"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>Created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ modifyParams.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ modifyParams.updated_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span class="title">{{ modifyParams.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="modifyParams.title"
                >
                </quill-editor>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="modifyParams.content"
                >
                </quill-editor>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="save('modifyParams')"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import TextArea from '@/components/base/TextArea'
import NoticeComments from '@/views/boards/NoticeComments'

//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  name: 'notices',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList,
    TextArea,
    NoticeComments,
    'quill-editor': quillEditor
  },

  mixins: [
    getListStatus,
    swal,
    checkAll
  ],

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,

      createParams: {
        title: '',
        content: ''
      },

      modifyParams: {
        title: '',
        content: '',
        is_hidden: false
      },

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      showCreate: false,
      showModify: false,

      selected: [],

      status: 'all',

      filterBy: [
        {
          value: 'title',
          display: 'title'
        },

        {
          value: 'content',
          display: 'content'
        },

        {
          value: 'created_at',
          display: 'date posted'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'Posted on'
        }
      ],

      showTblSettings: false,
      tblSetting: 'notices',
      allCols: [
        {
          value: 'id',
          display: 'no'
        },
        {
          value: 'created_at',
          display: 'created_at'
        },
        {
          value: 'title',
          display: 'title'
        },
        {
          value: 'content',
          display: 'content'
        },
        {
          value: 'updated_at',
          display: 'updated_at'
        },
        {
          value: 'deleted_at',
          display: 'deleted_at'
        }
      ],

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  watch: {
    async $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      await this.search(this.generate($router.query))
    }
  },

  computed: {
    ...mapGetters('notice', ['notices', 'count'])
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.params = this.generate(this.$route.query)
    this.search()
  },

  methods: {
    ...mapActions('notice', [
      'get', 'update', 'create', 'delete'
    ]),

    async trigger (query) {
      let status = this.$route.params.status
      this.params = query || this.params
      this.$router.push({ path: `/notices/${status}`, query: this.params })
    },

    async search (query) {
      this.params = query || this.params
      this.status = this.$route.params.status

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({ status: this.status, params: this.params })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.notices.length) {
        this.isEmpty = true
      }
    },

    async visibility (board) {
      let success = async () => {
        this.update({ id: board.id, is_hidden: !board.is_hidden })
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Modify')
    },

    async save (key) {
      let alertTitle = key === 'modifyParams' ? 'Modify Notice' : 'Create Notice'
      let success = async () => {
        if (!this.showDataLoading) {
          this.showDataLoading = true
        }

        if (this[key].id) {
          await this.update(this[key])
        } else {
          this[key].id = await this.create(this[key])
        }

        this.get(this.params)
        this.reset()

        this.showDataLoading = false
        this.showCreate = false
        this.showModify = false
      }

      if (this[key].title === '' || this[key].content === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      if (this[key].title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this[key].content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, alertTitle)
    },

    async deleteData () {
      let success = async () => {
        for (var x = 0; x < this.selected.length; x++) {
          await this.delete(this.selected[x])
        }

        this.selected = []
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Delete ?')
    },

    async restore () {
      let success = async () => {
        for (var x = 0; x < this.selected.length; x++) {
          await this.update({ id: this.selected[x], deleted_at: null })
        }

        this.selected = []
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Restore ?')
    },

    reset () {
      this.modifyParams = {
        title: '',
        content: '',
        is_hidden: false
      }

      this.createParams = {
        title: '',
        content: ''
      }
    },

    select (row) {
      this.modifyParams = Object.assign({}, row)
      this.showModify = true
      console.log(this.modifyParams)
    }
  }
}
</script>
